import React, { useState, useEffect } from 'react';
import homeData from '../data/home.js'; // Import the data object from home.js

const InfiniteReviewCarousel = () => {
  // Initialize state with the nested reviews array
  // Adjust this based on the exact structure of homeData
  const [reviewData, setReviewData] = useState(homeData.reviews.reviews); 
  
  // State to hold the index of the currently displayed review
  const [currentIndex, setCurrentIndex] = useState(0);

  // useEffect hook to set a random starting review ONLY on the initial component mount.
  // The empty dependency array `[]` ensures this effect runs just once.
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * reviewData.length);
    setCurrentIndex(randomIndex);
  }, []);

  // --- Navigation Handlers ---
  const goToPrevious = () => {
    // This calculation ensures the index loops correctly from 0 to the end of the array
    const newIndex = (currentIndex - 1 + reviewData.length) % reviewData.length;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    // This calculation ensures the index loops correctly from the end back to 0
    const newIndex = (currentIndex + 1) % reviewData.length;
    setCurrentIndex(newIndex);
  };

  // The currently active review object
  const activeReview = reviewData[currentIndex];

  return (
    <>
      {/* This style tag defines a simple fade-in animation. 
          Placing it here makes the component fully self-contained.
      */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.98); }
            to { opacity: 1; transform: scale(1); }
          }
        `}
      </style>
      
      <div style={styles.carouselContainer}>
        <button onClick={goToPrevious} style={styles.arrow} aria-label="Previous review">
          &#x276E;
        </button>

        {/* The 'key={currentIndex}' is important. It tells React to re-render the
          component when the index changes, which re-triggers our CSS animation.
        */}
        <div key={currentIndex} style={styles.reviewContent}>
          {/* Access properties from activeReview */}
          <p style={styles.reviewText}>
              "
                <span dangerouslySetInnerHTML={{ __html: activeReview.body }} />
              "
          </p> 
          <p style={styles.reviewAuthor}>- {activeReview.source}</p>
        </div>

        <button onClick={goToNext} style={styles.arrow} aria-label="Next review">
          &#x276F;
        </button>
      </div>
    </>
  );
};

// --- Component Styles ---
// Using CSS-in-JS for portability. No external stylesheet needed.
const styles = {
  carouselContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem 1rem',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    maxWidth: '800px',
    margin: '2rem auto',
    fontFamily: 'sans-serif',
    color: '#333',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
  },
  arrow: {
    background: 'transparent',
    border: 'none',
    fontSize: '2.5rem',
    color: '#aaa',
    cursor: 'pointer',
    padding: '0 1rem',
    transition: 'color 0.2s ease-in-out',
  },
  reviewContent: {
    flexGrow: 1,
    textAlign: 'center',
    animation: 'fadeIn 0.6s ease-in-out',
  },
  reviewText: {
    fontSize: '1.2rem',
    fontStyle: 'italic',
    lineHeight: '1.6',
    marginBottom: '1rem',
    color: '#555',
  },
  reviewAuthor: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#333',
  },
};

export default InfiniteReviewCarousel;